import React, { useEffect, useState } from 'react';
import { Stack, Grid, Card, Box, CardHeader, IconButton } from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import Datepicker from '../form-elements/datepicker.component';
import { getSummary } from '../../services/reports.service';
import { formatDate, getDate } from '../../utils/datetime.util';
import PLATFORMS_LIST, {
  getPlatformColorCode,
} from '../../config/platforms.config';
import Iconify from '../common/iconify.component';

const PieChart = () => {
  const [xLabels, setXLabels] = useState([]);
  const [sessionPCount, setSessionPCount] = useState([]);
  const [chartColors, setChartColors] = useState([]);

  const [filters, setFilters] = useState({
    channel: null,
    startDate: getDate(-7),
    endDate: getDate(0),
    reloadCounter: 0,
    loading: true,
  });

  const optionsSessPerCount = {
    series: sessionPCount,
    chart: {
      width: 380,
      type: 'pie',
    },
    labels: xLabels,
    colors: chartColors,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  const handleStartDateChange = (v) => {
    if (filters.loading) return;
    setFilters({
      ...filters,
      startDate: v,
      reloadCounter: filters.reloadCounter + 1,
      loading: true,
    });
  };
  const handleEndDateChange = (v) => {
    if (filters.loading) return;
    setFilters({
      ...filters,
      endDate: v,
      reloadCounter: filters.reloadCounter + 1,
      loading: true,
    });
  };
  const handleRefreshData = () => {
    if (filters.loading) return;
    setFilters({
      ...filters,
      reloadCounter: filters.reloadCounter + 1,
      loading: true,
    });
  };

  useEffect(() => {
    const startDate = formatDate(filters.startDate, 'YYYY-MM-DD');
    const endDate = formatDate(filters.endDate, 'YYYY-MM-DD');

    getSummary(startDate, endDate)
      .then((res) => {
        const platform = [];
        const sC = [];
        const colors = [];

        res.data.forEach((pd) => {
          platform.push(PLATFORMS_LIST.find((p) => p.id === pd.platform).title);
          sC.push(parseFloat(pd.sessionPercentageCount));
          colors.push(getPlatformColorCode(pd.platform));
        });

        setSessionPCount(sC);
        setXLabels(platform);
        setChartColors(colors);

        setFilters({ ...filters, loading: false });
      })
      .catch(() => {
        // TODO
        setFilters({ ...filters, loading: false });
      });
  }, [filters.reloadCounter]);

  return (
    <Card>
      <CardHeader
        title="App Sessions Percentage"
        subheader="Platform wise percentage of app sessions"
        action={
          <IconButton title="Refresh" onClick={handleRefreshData}>
            <Iconify icon="ic:twotone-refresh" />
          </IconButton>
        }
      />

      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Datepicker
            id="dr_start_date"
            name="dr_start_date"
            label="Start Date"
            defaultValue={filters.startDate}
            onChange={handleStartDateChange}
            sx={{ width: 200 }}
            readOnly={filters.loading}
          />
          To
          <Datepicker
            id="dr_end_date"
            name="dr_end_date"
            label="End Date"
            defaultValue={filters.endDate}
            onChange={handleEndDateChange}
            sx={{ width: 200 }}
            readOnly={filters.loading}
          />
        </Stack>

        {!sessionPCount.length && (
          <Grid
            direction="row"
            maxWidth="lg"
            height={400}
            justifyContent="center"
            alignItems="center"
            display="flex"
          >
            <div style={{ fontWeight: 700 }}>
              No reports available for app session percentage summary per
              platform.
            </div>
          </Grid>
        )}

        {sessionPCount.length > 0 && (
          <Stack sx={{ marginTop: 3.5 }}>
            <ReactApexChart
              type="pie"
              series={sessionPCount}
              options={optionsSessPerCount}
              height={364}
            />
          </Stack>
        )}
      </Box>
    </Card>
  );
};

export default PieChart;
